export enum BreakPointsPx {
    "xs" = "480px",
    "sm" = "640px",
    "md" = "768px",
    "mdPlus" = "830px",
    "lg" = "1024px",
    "2lg" = "1200px",
    "xl" = "1280px",
    "2xl" = "1536px",
}

export enum BreakPointsNumbers {
    "xs" = 480,
    "sm" = 640,
    "md" = 768,
    "mdPlus" = 830,
    "lg" = 1024,
    "xl" = 1280,
    "2xl" = 1536,
}
